import { css, SerializedStyles } from '@emotion/react';
import type { ReactElement } from 'react';

import { styled } from '../../../styled';

const styles = (): SerializedStyles => css`
	cursor: pointer;
	height: '24px';
	& > svg {
		display: block;
	}
`;

export const DotsIcon = styled(
	({ onClick, className }: { onClick: VoidFunction; className: string; withMarginRight: boolean }): ReactElement => (
		<svg
			width="24"
			height="24"
			className={className}
			onClick={onClick}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19 10C20.1 10 21 10.9 21 12C21 13.1 20.1 14 19 14C17.9 14 17 13.1 17 12C17 10.9 17.9 10 19 10ZM10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12ZM3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10C3.9 10 3 10.9 3 12Z"
				fill="white"
			/>
		</svg>
	)
)(styles, ({ withMarginRight }: { withMarginRight: boolean }) => (withMarginRight ? { marginRight: '10px' } : ''));
